import template from './get-additional-benefits.jade';
import getAdditionalBenefitsCtrl from './get-additional-benefits.controller';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: getAdditionalBenefitsCtrl,
    controllerAs: 'getAdditionalBenefitsCtrl',
    replace: true,
  };
};
